import { ORDERS_NS } from "@/i18n/ns";
export const FORM_ID = "task_payout_request_form";
export const ns = `${ORDERS_NS}:payout_request_form.`;
